
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled, { css } from 'styled-components';

const Wrapper = styled.div`
  display: grid;
  transition: all 0.5s;
  padding-bottom: ${({ doubleGrid }) => (doubleGrid ? '20px' : '0')};
  grid-template-columns: ${({ doubleGrid }) =>
    doubleGrid ? '1fr' : 'minmax(0, 1fr) 400px'};
  background: ${({ doubleGrid }) => (doubleGrid ? '#F7F9FA' : 'white')};
  grid-gap: ${({ doubleGrid }) => (doubleGrid ? '10px' : '50px')};
  .image-side {
    padding-bottom: ${({ isSquare }) => (isSquare ? '100%' : '65%')};
    position: relative;
    background: #f7f9fa;

    .add-to-cart-button,
    .finish-customizing {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      margin: auto;
      opacity: 0;
      transition: all 0.3s;
    }

    &:hover {
      .add-to-cart-button,
      .finish-customizing {
        opacity: 1;
      }
    }

    .image-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        width: 100%;
        height: 100%;
      }

      .sold-out-flag {
        display: ${({ doubleGrid }) => (doubleGrid ? 'auto' : 'none')};
        position: absolute;
        top: 0;
        right: 0;
      }

      .product-image {
        transition: all 0.3s;
        height: ${({ isSquare }) => (isSquare ? 'auto' : '80%')};
        width: ${({ isSquare }) => (isSquare ? '80%' : 'auto')};
      }

      &:hover {
        .product-image {
          transform: scale(1.05);
        }
      }
    }
  }
  .content-side {
    display: flex;
    align-items: center;

    a {
      text-decoration: none;
      &:hover {
        text-decoration: none;
      }
    }

    ${({ doubleGrid }) =>
      doubleGrid &&
      css`
        .info-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .sizes {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: center;
        }

        .throw-pillow-sizes {
          width: 390px;
        }
        .see-full-details-link {
          margin-top: 15px;
        }
      `}
    .sizes, .orientations {
      margin: ${({ doubleGrid }) => (doubleGrid ? '15px 0 0 0' : '15px 0')};
    }
  }

  .legs-badge {
    position: absolute;
    bottom: 20px;
    right: 20px;
    background: #a83569;
    border-radius: 0px 16px;
    color: #f8f8f8;
    padding: 4px 12px;
    font-size: 13px;
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`;

function ProductSkeleton({ doubleGrid }) {
  const isSquare = false;

  return (
    <WrapperContainer className="wrapper-product" isSquare={isSquare}>
      <Wrapper className="product" doubleGrid={doubleGrid} isSquare={isSquare}>
        <div className="image-side">
          <div className="image-container">
            <Skeleton />
          </div>
        </div>
        <div className="content-side">
          <div className="info-container">
            {!doubleGrid ? (
              <Title>
                <Skeleton width={250} height={30} />{' '}
              </Title>
            ) : (
              <SimpleTitle>
                {' '}
                <Skeleton width={250} height={30} />
              </SimpleTitle>
            )}

            <Skeleton width={100} height={30} />

            {!doubleGrid ? (
              <>
                <Price>
                  <Skeleton width={60} height={30} />
                </Price>{' '}
                <Text>
                  <Skeleton count={5} />
                </Text>
              </>
            ) : (
              <SimplePrice>
                {' '}
                <Skeleton />
              </SimplePrice>
            )}

            <Skeleton width={200} height={56} />
          </div>
        </div>
      </Wrapper>
    </WrapperContainer>
  );
}

export default ProductSkeleton;

const WrapperContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

const UnavailableBadge = styled.div`
  background: #a83569;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-transform: none;

  height: 25px;

  display: flex;
  justify-content: center;
  align-items: center;

  white-space: nowrap;
  position: absolute;
  /* padding: 5px 100px; */
  min-width: 300px;
  transform: rotate(-45deg) translate(-37%, 0);
  color: white;
  text-align: center;
  font-size: 12px;
  right: -152px;
  bottom: 150px;
  box-sizing: border-box;

  @media (max-width: 992px) {
    transform: rotate(-45deg) translate(-35%, 0);
    width: 100%;
    right: -25%;
    top: 0;
    bottom: auto;
  }
`;

const Overlay = styled.div`
  display: grid;
  grid-template-columns: ${({ doubleGrid }) =>
    doubleGrid ? '1fr' : 'minmax(0, 1fr) 400px'};
  grid-gap: ${({ doubleGrid }) => (doubleGrid ? '0' : '40px')};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.4);
  z-index: 7;

  .badge-container-wrapper {
    position: relative;
    overflow: hidden;
    order: ${({ doubleGrid }) => (doubleGrid ? '1' : '-1')};
  }

  @media (max-width: 1100px) {
    grid-gap: 00px;
  }

  .crossed-container {
    padding-bottom: ${({ isSquare }) => (isSquare ? '100%' : '65%')};
    position: relative;
    height: 0;

    .crossed {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      display: flex;
      justify-content: center;
      align-items: center;

      background: linear-gradient(
        to top left,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0) calc(50% - 2px),
        rgba(255, 255, 255, 1) 50%,
        rgba(0, 0, 0, 0) calc(50% + 2px),
        rgba(0, 0, 0, 0) 100%
      );

      .unavailable-text {
        font-family: ${({ theme }) => theme.fonts.primary};
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 33px;
        color: ${({ theme }) => theme.colors.charcoal};
      }
    }
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    grid-gap: 20px;

    .badge-container-wrapper {
      .badge-container {
        overflow: hidden;
        width: 100%;
        padding-bottom: 56%;
        position: relative;
      }
    }

    .crossed-container {
      .crossed {
        .unavailable-text {
          font-size: 14px;
          line-height: 19px;
        }
      }
    }
  }
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 0px;

  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-size: 32px;
  line-height: 42px;

  color: ${({ theme }) => theme.colors.charcoal};
  @media (max-width: 992px) {
    font-size: 24px;
    line-height: 24px;
  }
`;

const SimpleTitle = styled.div`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.charcoal};
`;

const Price = styled.div`
  margin-top: 20px;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 0.04em;

  color: ${({ theme }) => theme.colors.charcoal};
  @media (max-width: 992px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const SimplePrice = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.charcoal};
`;

const Text = styled.div`
  margin: 15px 0;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;

  @media (max-width: 992px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const LearnMoreText = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 13px;
  line-height: 23px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.charcoal};

  .hover-items {
    transition: visibility 0s, opacity 0.5s linear;
    opacity: ${({ isHovered }) => (isHovered ? '1' : '0')};
    visibility: ${({ isHovered }) => (isHovered ? 'visible' : 'hidden')};
  }

  &:hover {
    .hover-items {
      visibility: visible;
      opacity: 1;
    }
  }
  @media (max-width: 992px) {
    font-size: 13px;
    line-height: 23px;
  }
`;

const SizeButton = styled.div`
  cursor: pointer;
  margin: 5px;
  background: ${({ doubleGrid }) => (!doubleGrid ? '#f7f9fa' : 'white')};
  border: ${({ selected, doubleGrid }) =>
    selected
      ? '2px solid #2A5CAF'
      : !doubleGrid
      ? '1px solid #F7F9FA'
      : '1px solid #D8D8D8'};
  display: inline-block;
  padding: 10px 20px;
  border-radius: 30px;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.04em;

  color: ${({ selected, theme }) => (selected ?  theme.colors.charcoal: '#6c6c6c')};
`;
